import axios from "axios";
import React, {useEffect, useState} from 'react'
import FirstScreenSlider from "./first-screen/firstscreen-slider";
import Footer from "./parts/footer";
import CustomGallery from "./gallery/gallery";
import Formats from "./formats/formats";
import AdvantagesOne from "./advantages/advantages";
import Awarding from "./awarding/awarding";
import LeadMagnetOne from "./leadmagnet/leadmagnet-one";
import EbAutOne from "./ebaut-event/ebaut";
import Header from "./parts/header";
import EventThemesBase from "./themes/themes-base";
import EventSpeacersBase from "./speacers/speacers-base"
import EventPartnersBase from "./partners/partners-base"
import EventPartnersTop from "./partners/partners-top"
import EventPanelBase from "./panel/panel-base";
import EventProgram from "./program/program-base"

function Home() {

    const [post, setPosts] = useState([]);

    const fetchPosts = () => {
        axios
            .get('https://ekonomika.ua/wp-json/wp/v2/events/1275?_fields=acf&acf_format=standard')
            .then((res) => {
                setPosts(res.data.acf);
            });
    }

    useEffect(() => {
        fetchPosts()
    }, [post.data])

    let advantagesData = post.advantages
    let ebautData = post.ebaut_event
    let fsData = post.fs_group
    let formatsData = post.formats
    let myGallery = post.gallery
    let awardingData = post.awarding
    let speacersData = post.speacers
    let partnersBaseData = post.partners_bottom
    let partnersTopData = post.top_partners
    let panelData = post.panel
    let themesData = post.theme
    let programData = post.program

    return (
        <>
            <Header/>
            <FirstScreenSlider fsData={fsData} />
            <EventPartnersTop partnersTopData={partnersTopData} />
            <EbAutOne ebautData={ebautData} />
            <EventThemesBase themesData={themesData} />
            <EventSpeacersBase speacersData={speacersData} />
            <EventPanelBase panelData ={panelData}  />
            <EventProgram programData={programData} />
            <AdvantagesOne advantagesData={advantagesData} />
            <Formats formatsData={formatsData} />
            <EventPartnersBase partnersBaseData={partnersBaseData}/>
            <CustomGallery myGallery={myGallery} />
            <LeadMagnetOne />
            <Awarding awardingData={awardingData} />
            <Footer />
        </>
    )
}

export default Home;